import React, { FC } from 'react'
import cx from 'classnames'

type Props = {
  'data-cy'?: string
  'data-testid'?: string
  'data-id'?: string
  className?: string
  children?: React.ReactNode
}

const FormCard: FC<Props> = ({
  children,
  'data-cy': dataCy,
  'data-testid': dataTestId,
  'data-id': dataId,
  className,
}) => {
  return (
    <div
      data-cy={dataCy}
      data-testid={dataTestId}
      data-id={dataId}
      className={cx(
        'my-6 p-6 border border-coolGray-300 bg-gray-50 bg-opacity-25',
        className
      )}
    >
      {children}
    </div>
  )
}

export default FormCard
